import script from "./StepBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepBar.vue?vue&type=script&setup=true&lang=ts"

import "./StepBar.vue?vue&type=style&index=0&id=33879e20&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33879e20"]])

export default __exports__